import p from '../../styles/Profile.module.css';
import BackHome from "../../components/BackHome";

function Macos() {
    const steps = [
        { text: 'Скачайте приложение FoXray или V2Box из Mac App Store', href: 'https://apps.apple.com/ru/app/foxray/id6448898374' },
        { text: 'Скопируйте ссылку на подписку из вашего профиля', href: null },
        { text: 'Откройте приложение, перейдите в раздел "Subscriptions" (Подписки)', href: null },
        { text: 'Нажмите на кнопку "+" (Добавить) и вставьте скопированную ссылку', href: null },
        { text: 'Обновите подписку, выберите нужную локацию и нажмите кнопку "Старт"', href: null },
    ];

    return (
        <>
            <BackHome />
            <div className={p.page}>
                <div className={p.section}>
                    <p className={p.section_title} style={{ cursor: 'default' }}>
                        Инструкция по настройке macOS
                    </p>
                    
                    <div className={p.steps}>
                        {steps.map((step, i) => (
                            <div className={p.step_row} key={i}>
                                <div className={p.step_num}>{i + 1}</div>
                                <p className={p.step_text}>
                                    {step.href ? (
                                        <a href={step.href} className={p.step_link} target="_blank" rel="noreferrer">
                                            {step.text}
                                        </a>
                                    ) : (
                                        step.text
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Macos;